export const SET_COTACOES = 'cotacoes';
export const SET_VIEW_TYPE = 'viewType';
export const SET_SELECTED_STATUS = 'selectedStatus';
export const SET_FORNECEDORES = 'fornecedores';
export const SET_COTACOES_ITENS = 'cotacoesItens';
export const SET_SHOW_ESPECIFICACAO = 'showEspecificacao';
export const SET_SHOW_ESPECIFICACAO_FORNECEDOR = 'showEspecificacaoFornecedor';
export const SET_SHOW_PRECO_SEM_ICMS = 'showPrecoSemIcms';
export const SET_TIPO_VISUALIZACAO = 'tipoVisualizacao';
export const SET_SHOW_PERCENTUTAL_ICMS = 'showPercentualIcms';
export const SET_SHOW_PRECO_TARGET = 'showPrecoTarget';

export const CLEAR = 'clear';
